import { STORAGE_KEYS } from '@/constants/storage'
import { create } from 'zustand'
import { getDictList, type DictValue } from '@/utils/income-dict'
import type { BankCard } from '@/apis/income.types'
// 授信相关参数
interface IncomeData {
  accessToken: string
  flowType: string
  mobile: string
  flowChannelCode: string
  productCode: string
  channelCode: string
  redirectUrl: string
  amt?: string
  orderNo?: string
}

type DictItem = {
  label: string
  value: string
} & DictValue

const useIncomeStore = create<{
  incomeData: IncomeData
  setIncomeData: (data?: Partial<IncomeData>) => void

  repayBankInfo: BankCard

  setRepayBankInfo: (data: BankCard) => void

  dictMap: Record<string, DictItem[]>
  getAllDict: () => Promise<void>
}>((set, get) => ({
  incomeData: localStorage.getItem(STORAGE_KEYS.INCOME_DATA)
    ? JSON.parse(localStorage.getItem(STORAGE_KEYS.INCOME_DATA) || '{}')
    : {
      accessToken: '',
      flowType: '',
      mobile: '',
      flowChannelCode: '',
      productCode: '',
      channelCode: '',
      redirectUrl: '',
    },
  setIncomeData: (data?: Partial<IncomeData>) => {
    if (!data) {
      localStorage.removeItem(STORAGE_KEYS.INCOME_DATA)
      set({
        incomeData: {
          accessToken: '',
          flowType: '',
          mobile: '',
          flowChannelCode: '',
          productCode: '',
          channelCode: '',
          redirectUrl: '',
        },
      })
      return
    }
    const incomeData = {
      ...get().incomeData,
      ...data,
    }
    localStorage.setItem(STORAGE_KEYS.INCOME_DATA, JSON.stringify(incomeData))
    set({
      incomeData,
    })
  },

  repayBankInfo: { bankCode: '', bankName: '', bankCardNo: '' },

  setRepayBankInfo: (data: BankCard) => {
    set({ repayBankInfo: data })
  },

  dictMap: localStorage.getItem(STORAGE_KEYS.INCOME_DICT) 
    ? JSON.parse(localStorage.getItem(STORAGE_KEYS.INCOME_DICT) || '{}') 
    : {},
  getAllDict: async () => {
    const res = await getDictList()
    const map: Record<string, DictItem[]> = {}
    res.data.forEach((item) => {
      map[item.dictType] = item.dictValues.map((valueItem) => ({
        ...valueItem,
        label: valueItem.dictLabel,
        value: valueItem.dictValue,
      }))
    })
    console.log({ incomeDict: map })
    localStorage.setItem(STORAGE_KEYS.INCOME_DICT, JSON.stringify(map))
    set({ dictMap: map})
  },
}))

export default useIncomeStore